import React, { forwardRef, Ref, ChangeEvent, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import './index.css'
interface InputGenericoProps {
  name?: string;
  value?: string | number;
  onChange?:
  | ((event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void)
  | undefined;
  label?: string;
  placeholder?: string;
  className?: string;
  classNameLabel?: string;
  validacaoAtiva?: boolean;
  disabled?: boolean;
  type?: "text" | "number" | "date" | "textarea" | "password" | "email" | 'radio' | 'checkbox';
  temLabel?: boolean;
  required?: boolean;
  min?: any;
  max?: any;
  rows?: number;
  onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  maxLength?: number;
  displayFlex?: boolean;
}

const InputGenerico = forwardRef((
  { name,
    value,
    onChange,
    label,
    placeholder,
    className,
    classNameLabel,
    validacaoAtiva,
    disabled,
    type,
    temLabel,
    required,
    min,
    max,
    rows,
    onBlur,
    maxLength,
    displayFlex,
  }: InputGenericoProps,
  ref: Ref<HTMLInputElement | HTMLTextAreaElement>
) => {


  const handleDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const currentDate = new Date().toLocaleDateString('en-CA');
    if (validacaoAtiva && inputValue < currentDate) {
      event.target.value = currentDate;
    } else if (!validacaoAtiva && inputValue >= calcularDataLimiteIdade()) {
      event.target.value = calcularDataLimiteIdade();
    }
    if (onChange) {
      onChange(event);
    }
  };

  const calcularDataLimiteIdade = () => {
    const currentDate = new Date();
    const limiteDeIdade = new Date(currentDate.getFullYear() - 16, currentDate.getMonth(), currentDate.getDate());
    return limiteDeIdade.toISOString().split('T')[0];
  };
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const toggleMostrarSenha = () => {
    setMostrarSenha(!mostrarSenha);
  };
  return (
    <div className={`form-group ${displayFlex ? 'aplicarDisplayFlex' : ''}`}>
      <label htmlFor={name} className={`form-label ${classNameLabel}`} style={temLabel === false ? { display: 'none' } : {}}>
        {label}
      </label>
      {type === "text" && (
        <input
          ref={ref as Ref<HTMLInputElement>}
          type="text"
          className={`form-control ${className}`}
          id={name}
          name={name}
          value={value as string}
          onChange={onChange as ((event: ChangeEvent<HTMLInputElement>) => void)}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          style={{ resize: 'none' }}
        />
      )}
      {type === "textarea" && (
        <textarea
          ref={ref as Ref<HTMLTextAreaElement>}
          className={`form-control ${className} ${disabled ? 'cursorBlock' : ''}`}
          id={name}
          name={name}
          value={value as string}
          onChange={onChange as ((event: ChangeEvent<HTMLTextAreaElement>) => void)}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          rows={rows}
          style={{ resize: 'none' }}
          maxLength={maxLength}
        />
      )}
      {type === "number" && (
        <input
          ref={ref as Ref<HTMLInputElement>}
          type="number"
          className={`form-control ${className} ${disabled ? 'cursorBlock' : ''}`}
          id={name}
          name={name}
          value={value as number}
          onChange={onChange as ((event: ChangeEvent<HTMLInputElement>) => void)}
          placeholder={placeholder}
          disabled={disabled}
          min={min}
          max={max}
        />
      )}
      {type === "date" && (
        <input
          ref={ref as Ref<HTMLInputElement>}
          type="date"
          className={`form-control ${className} ${disabled ? 'cursorBlock' : ''}`}
          id={name}
          name={name}
          value={value as string}
          onChange={handleDateChange}
          placeholder={placeholder}
          disabled={disabled}
          min={min}
          max={max}
        />
      )}
      {type === "password" && (
  <div className="inputTipoPassword">
    <input
      ref={ref as Ref<HTMLInputElement>}
      type={mostrarSenha ? "text" : "password"}
      className={`form-control ${className}`}
      id={name}
      name={name}
      value={value as string}
      onChange={onChange as ((event: ChangeEvent<HTMLInputElement>) => void)}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
    />
    <FontAwesomeIcon
      icon={mostrarSenha ? faEye : faEyeSlash}
      className="icon-eye"
      onClick={toggleMostrarSenha}
    />
  </div>
)}

      {type === "email" && (
        <input
          ref={ref as Ref<HTMLInputElement>}
          type="email"
          className={`form-control ${className}`}
          id={name}
          name={name}
          value={value as string}
          onChange={onChange as ((event: ChangeEvent<HTMLInputElement>) => void)}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          min={min}
          max={max}
          onBlur={onBlur}
          maxLength={maxLength}
        />
      )}
      {type === "checkbox" && (
        <input
          ref={ref as Ref<HTMLInputElement>}
          type="checkbox"
          className={`form-check-input ${className}`}
          id={name}
          name={name}
          value={value as string}
          onChange={onChange as ((event: ChangeEvent<HTMLInputElement>) => void)}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          onBlur={onBlur}
        />
      )}
    </div>
  );
});

export default InputGenerico;
